import { Datei } from '../datei/datei.model';
export class Eintrag {
  id: string;
  text: string;
  // date: Date;
  ablaufdatum: Date;
  typ: number;
  createDate: Date;
  anhang: Datei[];
  kategorie: string;
  betrachtet: boolean;
  unterzeichnet: Date;
}
